module.exports = __webpack_public_path__ + "media/images/ioscor-loguito-fe1a0706c0de37dc434337d028ab2bc8.png";